import { AnimationDefinition } from "framer-motion";
import { createContext } from "react";

export type AnimationState = "unmounted" | "hidden" | "visible";

export const MenuTriggerContext = createContext<{
  currentAnimation: AnimationState;
  onComplete?: (definition: AnimationDefinition) => void;
}>({ currentAnimation: "unmounted", onComplete: undefined });
